import React from 'react';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import {
  selectCanonical,
  selectDescription,
  selectImage,
  selectKeywords,
  selectTitle,
} from '../../redux/meta/selectors';

export default function MetaHeader() {
  const title = useSelector(selectTitle);
  const description = useSelector(selectDescription);
  const keywords = useSelector(selectKeywords);
  const image = useSelector(selectImage);
  const canonical = useSelector(selectCanonical);

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="og:image" content={image} />
      {canonical && <link rel="canonical" href={canonical} />}
    </Helmet>
  );
}
